// extracted by mini-css-extract-plugin
module.exports = {"at-paginations":"Pagination_at-paginations__3v2hV"};